// Firebase yapılandırması
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getDatabase } from 'firebase/database';

// Firebase config
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyB-xeBtNtupiV28NDJcsIhRO769oOc0248",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "salonkoltuk.firebaseapp.com",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://salonkoltuk-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "salonkoltuk",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "salonkoltuk.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "697628635838",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:697628635838:web:6ae816d3c4d8fc0602a4ef",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-BZ5QQV022Z"
};

// Firebase'i başlat
const app = initializeApp(firebaseConfig);

// Analytics'i başlat (sadece browser'da)
let analytics;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Firebase servislerini export et
export const auth = getAuth(app);
export const database = getDatabase(app); // Realtime Database
export const storage = getStorage(app);
export { analytics };
export default app;

